import { ADMINISTRATION_PERSON_URL, API_UNIT } from "globals/constants";
import { spUrl } from "utils";
import { buildSearchParams, request } from "utils/proxy";


export const unit = {
	/**
	 * @param {{ id: string }} params
	 * @param {{}?} options
	 */

	get: (params, options) => request(spUrl(`${API_UNIT}/${params.id}`), options),

	/**
	 * @param {{ id: string }} params
	 * @returns {Promise<{}[]>} A Promise that resolves with the list of person affiliation.
	 */

	getAdminPersonAffiliations: id => request(`${ADMINISTRATION_PERSON_URL}/${id}/affiliation`),


	/**
	 * Retrieve a list of units.
	 *
	 * @param {object} params - Query parameters for filtering and pagination.
	 * @param {{}?} options - Request options.
	 * @param {number} [params.page] - The page number for pagination.
	 * @param {number} [params.size] - The number of items per page.
	 * @param {string[]} [params.search] - A search term for filtering.
	 *
	 * @returns {Promise<{}[]>} A Promise that resolves with the list of units.
	 */
	findAll: (params, options) => request(spUrl(`${API_UNIT}${buildSearchParams(params)}`), options),

};
